export default "__VITE_ASSET__rcUMCOfR__"